(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quova-header"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var h=document.getElementById('qvHeader'),
        b=document.getElementById('qvBurger'),
        n=document.getElementById('qvNav');
    if(!h) return;
    function s(){ h.classList.toggle('is-stuck', window.scrollY>40); }
    s(); window.addEventListener('scroll', s, {passive:true});
    if(b&&n){
      b.addEventListener('click',function(){
        var o=n.classList.toggle('is-open');
        b.setAttribute('aria-expanded', o?'true':'false');
        document.body.style.overflow = o?'hidden':'';
      });
      n.addEventListener('click',function(e){
        if(e.target.tagName==='A'){
          n.classList.remove('is-open');
          b.setAttribute('aria-expanded','false');
          document.body.style.overflow='';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quova-product"]) return;
  try {
    
  (function(){
    var form = document.getElementById('qvForm');
    if(!form) return;

    var dataEl = document.getElementById('qvVariantData');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch(e){ return; }

    var idField  = document.getElementById('qvVariantId');
    var addBtn   = document.getElementById('qvAdd');
    var soldOut  = document.getElementById('qvSoldOut');
    var priceEl  = document.querySelector('.qv-pdp-price');
    var optGroups = Array.prototype.slice.call(document.querySelectorAll('.qv-pdp-opt'));

    function selected(){
      return optGroups.map(function(g){
        var active = g.querySelector('.qv-pdp-val.is-active');
        return active ? active.dataset.val : null;
      });
    }

    function findVariant(choice){
      return variants.find(function(v){
        return choice.every(function(val, i){
          return val === null || v.options[i] === val;
        });
      });
    }

    function money(cents){
      return '$' + (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function markUnavailable(){
      var choice = selected();
      optGroups.forEach(function(g, gi){
        g.querySelectorAll('.qv-pdp-val').forEach(function(btn){
          var test = choice.slice();
          test[gi] = btn.dataset.val;
          var match = variants.find(function(v){
            return test.every(function(val,i){ return val === null || v.options[i] === val; });
          });
          btn.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    
    function update(){
      var choice = selected();
      var v = findVariant(choice);

      optGroups.forEach(function(g){
        var active = g.querySelector('.qv-pdp-val.is-active');
        var label  = g.querySelector('.qv-pdp-opt-current');
        if(label && active) label.textContent = active.dataset.val;
      });

      markUnavailable();
       try {
        var cm = JSON.parse(document.getElementById('qvColorMedia').textContent);
        var target = cm[choice[0]];
        if(typeof target === 'number'){
          document.querySelectorAll('.qv-pdp-thumb').forEach(function(t){
            t.classList.toggle('is-active', t.dataset.index == target);
          });
        }
      } catch(e){}
      if(v){
        idField.value = v.id;
        if(priceEl) priceEl.textContent = money(v.price);
        if(v.available){
          addBtn.removeAttribute('disabled');
          addBtn.querySelector('span').textContent = addBtn.dataset.label || addBtn.querySelector('span').textContent;
          soldOut.hidden = true;
        } else {
          addBtn.setAttribute('disabled','');
          soldOut.hidden = false;
        }
      } else {
        addBtn.setAttribute('disabled','');
        soldOut.hidden = false;
      }
    }

    optGroups.forEach(function(g){
      g.addEventListener('click', function(e){
        var btn = e.target.closest('.qv-pdp-val');
        if(!btn) return;
        g.querySelectorAll('.qv-pdp-val').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        update();
      });
    });
    var thumbs = document.querySelectorAll('.qv-pdp-thumb');
    var shots  = document.querySelectorAll('.qv-pdp-shot');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        var i = t.dataset.index;
        thumbs.forEach(function(x){ x.classList.toggle('is-active', x.dataset.index === i); });
                  var s = document.querySelector('.qv-pdp-shot[data-index="'+i+'"]');
          if(s) s.scrollIntoView({ behavior:'smooth', block:'start' });
      });
    });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quova-size-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e){
    var link = e.target.closest('a[href="#qvSizeGuide"]');
    if(!link) return;
    var d = document.getElementById('qvSgDetails');
    if(d) d.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
